import { mapActions } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { PetNoteCacheMixin } from './PetNoteCacheMixin'

export const PetNoteAddMixin = {
  mixins: [PetNoteCacheMixin],
  data () {
    return {
      noteText: ''
    }
  },
  computed: {
    petNoteAddModel () {
      return Object.assign({}, this.ownerQueryModel, {
        noteTypeId: this.noteTypeId,
        text: this.noteText
      })
    }
  },
  methods: {
    ...mapActions('RegistrationPetNotes', [
      'addPetNote'
    ]),
    tryAddPetNote () {
      const self = this
      self.error = ''
      return self.addPetNote({ inviteId: self.inviteId, payload: self.petNoteAddModel })
        .then(response => { self.afterAddPetNote(response.data) })
        .catch(error => {
          if (ErrorHelper.isNotFound(error)) {
            self.afterAddPetNote()
          } else {
            self.error = ErrorHelper.getError(error)
          }
        })
    },
    afterAddPetNote () {
      // override if necessary
    }
  }
}
